import { Routes, Route, Navigate } from 'react-router-dom';
import AuthChecker from './components/AuthChecker';
import LandingPage from './pages/LandingPage';
import EmailLogin from './pages/EmailLogin';
import ResetPasswordPage from './pages/ResetPasswordPage';
import CompleteProfile from './pages/CompleteProfile';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Dashboard from './pages/Dashboard';
import DashboardLayout from './components/DashboardLayout';
import ParentDashboard from './pages/dashboards/ParentDashboard';
import BabysitterDashboard from './pages/dashboards/BabysitterDashboard';
import AdminDashboard from './pages/dashboards/AdminDashboard';
import AdminPanel from './pages/admin/AdminPanel';
import CalendarPage from './pages/dashboards/CalendarPage';
import PaymentsPage from './pages/dashboards/PaymentsPage';
import JobsPage from './pages/dashboards/JobsPage';
import CreateJobPage from './pages/dashboards/CreateJobPage';
import ProfilePage from './pages/dashboards/ProfilePage';
import EditProfilePage from './pages/dashboards/EditProfilePage';
import NotificationsPage from './pages/dashboards/NotificationsPage';
import FriendsPage from './pages/dashboards/FriendsPage';
import AcceptFriendInvitation from './pages/dashboards/AcceptFriendInvitation';
import ConversationsPage from './pages/dashboards/ConversationsPage';
import BabysitterProfilePage from './pages/dashboards/BabysitterProfilePage';
import JobPublicPage from './pages/JobPublicPage';
import NotificationSettingsPage from './pages/settings/NotificationSettingsPage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthChecker>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LandingPage initialAuthMode="login" />} />
        <Route path="/register" element={<LandingPage initialAuthMode="register" />} />
        <Route path="/email-login" element={<EmailLogin />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route
          path="/complete-profile"
          element={
            <ProtectedRoute allowIncompleteProfile>
              <CompleteProfile />
            </ProtectedRoute>
          }
        />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        {/* Javni profil dadilje – bez prijave (klik sa landinga) */}
        <Route path="/babysitter/:id" element={<BabysitterProfilePage />} />
        {/* Javni oglas posla – bez prijave */}
        <Route path="/job/:id" element={<JobPublicPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/parent"
          element={
            <ProtectedRoute requiredRole="parent">
              <ParentDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/babysitter"
          element={
            <ProtectedRoute requiredRole="babysitter">
              <BabysitterDashboard />
            </ProtectedRoute>
          }
        />
        {/* Dashboard Layout Routes */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="jobs" element={<JobsPage />} />
          <Route path="jobs/create" element={<CreateJobPage />} />
          <Route path="jobs/:id" element={<JobPublicPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="profile/edit" element={<EditProfilePage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="friends/accept" element={<AcceptFriendInvitation />} />
          <Route path="friends" element={<FriendsPage />} />
          <Route path="conversations" element={<ConversationsPage />} />
          <Route path="conversations/:conversationId" element={<ConversationsPage />} />
          <Route path="babysitter/:id" element={<BabysitterProfilePage />} />
          <Route path="settings" element={<NotificationSettingsPage />} />
          <Route path="settings/notifications" element={<Navigate to="/dashboard/settings" replace />} />
        </Route>
        <Route
          path="/dashboard/admin"
          element={
            <ProtectedRoute requiredRole="admin">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requiredRole="admin">
              <AdminPanel />
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthChecker>
  );
}

export default App;

